import classNames from "classnames";
import { map, uniq } from "lodash";
import { FC, HTMLAttributes } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { Paragraph } from "@datagame/ui";

import Upload from "../../../assets/images/Upload.png";

import styles from "./FileDropzone.module.scss";

interface FileDropzoneProps extends HTMLAttributes<HTMLDivElement> {
  onFileUpload: (acceptedFiles: File[]) => void;
  className?: string;
  maxFiles?: number;
}

const errorMessageTranslations: {
  [key: string]: string;
} = {
  "too-many-files": "fileDropzone.tooManyFiles",
  "file-invalid-type": "fileDropzone.fileInvalidType",
};

export const FileDropzone: FC<FileDropzoneProps> = ({ onFileUpload, className, maxFiles = 1, ...rootProps }) => {
  const { getRootProps, fileRejections, getInputProps, isDragActive } = useDropzone({
    onDrop: onFileUpload,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
    maxFiles,
  });

  const { t } = useTranslation("common");
  const fileRejectionErrors = map(fileRejections, (rejection) => rejection.errors).flat();
  const rejectionCodes = uniq(map(fileRejectionErrors, (error) => error.code));

  return (
    <>
      <div className={classNames(styles.root, className)} {...rootProps} {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive && <p className={styles.dropOverlay}>{t("library:dropFilesHere")}</p>}
        <div className={styles.content}>
          <img src={Upload} alt="Upload" />
          <div className={styles.descritpionWrapper}>
            <Paragraph color="neutrals-600" weight="font-bold">
              <span className={styles.browse}>{t("library:uploadSection.browse")}</span>
              {t("library:orDropFilesToUpload")}
            </Paragraph>
            <Paragraph color="neutrals-600">{t("library:supportedFormats")}</Paragraph>
          </div>
        </div>
      </div>
      <ul>
        {rejectionCodes.map((code) => (
          <li className={styles.error} key={code}>
            {t(errorMessageTranslations[code], { count: maxFiles })}
          </li>
        ))}
      </ul>
    </>
  );
};
